import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/UseAuth';
import DashboardHeader from '../../pages/Dashboard/DashboardHeader';
// --- INICIO DE LA MODIFICACIÓN 1: Importar LangLink ---
import { LangLink } from '../common/LangLink';
// --- FIN DE LA MODIFICACIÓN 1 ---

const DashboardLayout = () => {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  // --- INICIO DE LA MODIFICACIÓN 2: Añadir useLocation ---
  const location = useLocation();
  // --- FIN DE LA MODIFICACIÓN 2 ---

  // --- INICIO DE LA MODIFICACIÓN 3: Lógica 'isActive' corregida ---
  const currentPathWithoutLang = location.pathname.startsWith(
    `/${i18n.language}`
  )
    ? location.pathname.substring(i18n.language.length + 1)
    : location.pathname;

  const isActive = (path) => {
    if (
      path === '/dashboard' &&
      (currentPathWithoutLang === '/dashboard' ||
        currentPathWithoutLang === '/dashboard/')
    ) {
      return true;
    }
    if (path !== '/dashboard' && currentPathWithoutLang.startsWith(path)) {
      return true;
    }
    return false;
  };

  const getNavLinkClass = (path) => {
    const baseClasses =
      'py-3 px-4 text-sm font-semibold transition-colors border-b-2 whitespace-nowrap';
    return isActive(path)
      ? `${baseClasses} text-primary border-primary`
      : `${baseClasses} text-neutral-500 border-transparent hover:border-neutral-300 hover:text-neutral-800 dark:hover:text-neutral-200`;
  };
  // --- FIN DE LA MODIFICACIÓN 3 ---

  const navItems = [
    { to: '/dashboard', label: t('dashboard.layout.nav.summary') },
    { to: '/dashboard/analytics', label: t('dashboard.layout.nav.analytics') },
    { to: '/dashboard/referrals', label: t('dashboard.layout.nav.referrals') },
    { to: '/dashboard/posts', label: t('dashboard.layout.nav.posts') },
    { to: '/dashboard/packs', label: t('dashboard.layout.nav.galleries') },
    { to: '/dashboard/donations', label: t('dashboard.layout.nav.donations') },
    { to: '/dashboard/settings', label: t('dashboard.layout.nav.settings') },
  ];

  return (
    <div className="w-full">
      <div className="container-main flex flex-col gap-6 py-8">
        <DashboardHeader username={user?.username} />

        <nav className="flex items-center border-b border-neutral-200 dark:border-neutral-700 overflow-x-auto">
          {/* --- INICIO DE LA MODIFICACIÓN 4: Usar LangLink en lugar de NavLink --- */}
          {navItems.map((item) => (
            <LangLink
              key={item.to}
              to={item.to}
              className={getNavLinkClass(item.to)}
            >
              {item.label}
            </LangLink>
          ))}
          {/* --- FIN DE LA MODIFICACIÓN 4 --- */}
        </nav>

        <main className="w-full">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
